import { render, staticRenderFns } from "./InteresList.vue?vue&type=template&id=cafaf030"
import script from "./InteresList.vue?vue&type=script&lang=js"
export * from "./InteresList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports